﻿import * as Res from "./res";
import { dbfetch } from "./dbfetch";
import { isIOS } from "./browser";
import { createElement, unsafeSetHTML } from "./_dom";
import { FS } from "./_fs";
import { itembar } from "./itembar";

let activeRequestCount = 0;
let submitWasRequested = false;

const initScripts = [];

function $$(ctx/*, name, name...*/) {
	var s = [];
	for (var i = 1, a = arguments, l = a.length; i < l; i++)
		s[i - 1] = "[name=\"" + a[i] + "\"]";
	return (ctx || document).querySelectorAll(s.join(","));
}

function asFormData(e, formData) {
	if (!e.disabled) {
		if (e.matches("input[type=checkbox],input[type=radio]")) {
			if (e.checked) {
				formData.append(e.name, e.value || "on");
			}
		} else {
			formData.append(e.name, e.value);
		}
	}
}

const controlInterfaceBase = {
	getValue: function getValue(ctx, name) {
		const controls = $$(ctx, name);
		if (controls.length)
			return controls[0].value;
	},
	asString: function valueAsString(v) {
		return v ? v.toString() : "";
	},
	asParams: function valueAsFormData(ctx, name, formData) {
		$$(ctx, name).forEach(e => asFormData(e, formData));
	},
	setValue: function setValue(ctx, name, value) {
		$$(ctx, name).forEach(c => c.value = value != null ? value : "");
	},
	setHTML: function setHTML(ctx, name, html) {
		var cell = ctx.querySelector("#" + name + "_value");
		unsafeSetHTML(cell, html);
	}
};

// control types
const controlBehaviors = {
	html: {
		...controlInterfaceBase,
		setValue: controlInterfaceBase.setHTML
	},
	input: {
		...controlInterfaceBase
	},
	select: {
		...controlInterfaceBase,
		setValue: function setSelectValue(ctx, name, value) {
			value = value || "";
			$$(ctx, name).forEach(c => {
				const oo = c.options;
				for (let i = 0; i < oo.length; i++) {
					const o = oo[i];
					if (o.value == value) {
						c.selectedIndex = i;
						return;
					}
				}
				c.insertBefore(new Option(value, value), c.options[1]);
				c.selectedIndex = 1;
			});
		}
	},
	radio: {
		...controlInterfaceBase,
		getValue: function getRadioValue(ctx, name) {
			for (const c of $$(ctx, name)) {
				if (c.checked)
					return c.value;
			}
		},
		setValue: function setRadioValue(ctx, name, value) {
			$$(ctx, name).forEach(c => c.checked = c.value == value);
		}
	},
	check: {
		...controlInterfaceBase,
		getValue: function getCheckValue(ctx, name) {
			for (const c of $$(ctx, name)) {
				if (c.checked)
					return c.value;
			}
		},
		setValue: function setCheckValue(ctx, name, value) {
			value = !!value;
			$$(ctx, name).forEach(c => c.checked = value);
		}
	},
	mcheck: {
		...controlInterfaceBase,
		getValue: function getMultiCheckValue(ctx, name) {
			var r = [];
			$$(ctx, name).forEach(c => c.checked && r.push(c.value));
			return r;
		},
		setValue: function setMultiCheckValue(ctx, name, value) {
			if (!Array.isArray(value))
				value = [value];
			$$(ctx, name).forEach(c => c.checked = value.includes(c.value));
		}
	},
	mtext: {
		...controlInterfaceBase,
		asParams: function getMultilineFormData(ctx, name, formData) {
			return $$(ctx, name + "_h", name + "_o", name).forEach(e => asFormData(e, formData));
		},
		getValue: function (ctx, name) {
			var ctrl, value = "";
			ctrl = $$(ctx, name + "_h");
			if (ctrl.length)
				value += ctrl[0].value;
			ctrl = $$(ctx, name + "_o");
			if (ctrl && ctrl[0].value !== "") {
				if (value !== "") value += "\r\n";
				// insert TS for proper ops
				value += ctrl[0].value;
			}
			return value;
		},
		setValue: function (ctx, name, value) {
			var ctrl;
			ctrl = $$(ctx, name + "_h");
			if (ctrl.length) ctrl[0].value = value.h;
			ctrl = $$(ctx, name + "_o");
			if (ctrl.length) ctrl[0].value = value.o;
			unsafeSetHTML(document.getElementById(name), value.m);
		}
	},
	timestamp: {
		...controlInterfaceBase,
		getValue: function getTimestampValue(ctx, name) {
			var ctrl = $$(ctx, name);
			var v0 = ctrl[0].value, v1 = ctrl[1].value;
			return v0 !== "" ? [v0, v1] : null;
		},
		asString: function getTimestampAsString(value) {
			return value ? value.join("|") : "";
		},
		setValue: function setTimestampValue(ctx, name, value) {
			var ctrl = $$(ctx, name);
			ctrl.forEach((c, i) => c.value = value[i] || "");
		}
	},
	reference: {
		...controlInterfaceBase,
		getValue: function getReferenceValue(ctx, name) {
			var v = [];
			$$(ctx, name).forEach(e => {
				if (e.tagName !== "INPUT" ||
					e.type != "radio" && e.type != "checkbox" ||
					e.checked) {
					v.push(e.value);
				}
			});
			return v ? v.length == 1 ? v[0] : v : null;
		},
		asParams: function getReferenceFormData(ctx, name, formData) {
			$$(ctx, name, name + "_oldkeys", name + "_table", name + "_text", name + "_filter").forEach(e => asFormData(e, formData));
		},
		setValue: function setReferenceValue(ctx, name, value) {
			controlInterfaceBase.setHTML(ctx, name, value);
		}
	},
	attachment: {
		...controlInterfaceBase,
		asParams: function getAttachmentFormData(ctx, name, formData) {
			$$(ctx, name, name + "_guid", name + "_delete").forEach(e => asFormData(e, formData));
		},
		setHTML: function setAttachmentHtml(ctx, name, htmlText) {
			controlInterfaceBase.setHTML(ctx, name, htmlText); // call base
			if (htmlText) // force form to send form-data
				ctx.closest("form").setAttribute("enctype", "multipart/form-data");
		},
		setValue: function setAttachmentValue(ctx, name, value) {
			this.setHTML(ctx, name, value);
		}
	}
};

/// Displays "Are you sure?" on attempt to navigate away from changed form
function initChangeTracking(ctx) {
	// ctx.matches("form")
	function setBeforeUnload() {
		if (window.onbeforeunload == null) {
			window.onbeforeunload = function (e) {
				e.preventDefault();
				return Res.getString("form.confirmation_text") || "Some data was changed. Proceed without saving?";
			};
		}
	}
	function resetBeforeUnload() {
		window.onbeforeunload = null;
	}

	// new record set some c_f_'s to 1, ns=1 indicates record is new and not refreshed
	if (!ctx.querySelector("input[type=\"hidden\"][name=\"ns\"][value=\"1\"]") &&
		ctx.querySelector("input[type=\"hidden\"][name^=\"c_f_\"][value=\"1\"]"))
		setBeforeUnload();
	ctx.addEventListener("change", setBeforeUnload);
	ctx.addEventListener("submit", resetBeforeUnload);
	// click to any action button (namely Refresh) resets warning
	ctx.addEventListener("click",
		[ctx, document.querySelector(".v3-header__menu2>.v3-layout__actions")].forEach(element => element?.addEventListener("click", e => {
			if (e.target.closest(".v3-layout__actions .fs-action"))
				resetBeforeUnload();
		})));
}

function initForm(ctx) {
	initDynControls(ctx);
}

function addInitControl(fn) {
	initScripts.push(fn);
}

var touchEvents = "ontouchstart" in window;

function ensureVisible(/*element*/) {
	// TODO!
}

function setFocus(ctx) {
	// ios does not support programmatical focus properly
	if (isIOS)
		return;
	// set focus to first visible element
	if (window.getSelection) {
		window.getSelection().removeAllRanges();
	} else if (document.selection) {
		document.selection.empty();
	}

	// set the focus to first ***visible*** control
	for (const e of ctx.querySelectorAll('select,textarea,input:not([type="hidden"],[type="submit"],[type="reset"],[type="image"],[type="radio"],[type="checkbox"],[type="file"])')) {
		// visible or position:fixed (unlikely!)
		if (e.offsetParent != null) {
			e.focus();
			ensureVisible(e);
			break;
		}
	}
}

function initButtons(_ctx, formId, data) {
	const cancelLinkUrl = new URL(location.href);
	cancelLinkUrl.searchParams.set("_", new Date().valueOf());
	const saveButton = createElement("button", {
			class: "ui-button fs-action v3-button ui-action ui-action-save v3-button-default",
			type: "submit",
			value: "save",
			form: formId
		},
		Res.getString("action.save")
	);
	const saveNextButton = data.allowSaveNext ? createElement("button", {
			class: "ui-button fs-action v3-button ui-action ui-action-savenext ui-icon-next ui-iconafter",
			type: "button",
			value: "saveandnext",
			form: formId
		},
		Res.getString("action.saveandnext")
	) : null;
	const refreshButton = createElement("button", {
			class: "ui-button fs-action v3-button ui-action ui-action-refresh",
			type: "button",
			value: "refresh",
			form: formId
		},
		Res.getString("action.refresh")
	);
	const cancelButton = createElement('a', {
			class: "ui-button v3-button ui-action ui-action-cancel",
			href: cancelLinkUrl.toString(),
			dataset: { form: formId }
		},
		Res.getString("action.cancel")
	);
	const actions = [saveButton, saveNextButton, refreshButton, cancelButton].filter(Boolean);
	document.querySelectorAll(`${formId} .v3-layout__actions`).forEach(bar => {
		bar.replaceChildren(...actions);
	});
	const actionBar = document.querySelector(".v3-header__menu2>.v3-layout-actionbar");
	if (actionBar) {
		actionBar.replaceChildren(...actions.map(b => createElement("li", { "class": "v3-layout-actionbar__cell v3-itembar__cell" }, b)));
		itembar(actionBar).refresh();
	}
}

function initEdit(ctx, data) {
	Object.entries(data.controls).forEach(([n, c]) => {
		ctx.querySelector(`dl#${n}_label`).classList.toggle("v3-state-editable", !!c.ae);
	});
	if (ctx.querySelector("div.ui-gridlayout.fs-edit")) {
		initButtons(ctx, ctx.id, data);
	}
	initEditableHover(ctx, data);
}

function initDynControls(ctx) {
	initScripts.forEach(fn => fn(ctx));
}

async function fetchWithTimeout(resource, options = {}) {
	const { timeout = 60 * 1000 } = options;

	const abortController = new AbortController();
	const id = setTimeout(() => abortController.abort(), timeout);
	const response = await dbfetch(resource, {
		...options,
		signal: abortController.signal
	});
	clearTimeout(id);
	return response;
}

async function sendFormData(ctx, key, data, fromDoubleClick) {

	const ctls = data.controls;
	const body = new FormData();

	function asParams(key) {
		var c = ctls[key];
		c = c.t == 1 || c.t == 2 ? controlBehaviors[c.e] : controlBehaviors.input;
		c.asParams(ctx, key, body);
	}

	try {

		var qs, url = data.url;
		if (url) {
			var n = url.indexOf("?");
			if (n >= 0) {
				qs = new URLSearchParams(url.substring(n));
				url = url.substring(0, n);
			}
			else {
				qs = new URLSearchParams("");
			}
		}
		qs.set("cmd", fromDoubleClick ? "dblclk" : "dynrefresh");
		qs.set("f", key.substring(2));
		if (data.preview)
			qs.set("vc", 1);
		url += "?" + qs.toString();


		// generate old control state [hidden/visible/readonly/editable]
		for (var x in ctls) {
			body.append("OT_" + x, ctls[x].t);
			var eid = "e_" + x;
			$$(ctx, eid).forEach(c => body.append(c.name, c.value));
		}
		// generate current control's value
		asParams(key);
		// generate dependent controls, if any
		var deps = data.dependencies[key];
		if (deps) {
			deps = deps.controls;
			for (var i = 0; i < deps.length; i++) {
				var k = deps[i];
				asParams(k);
				var xk = "c_" + k;
				$$(ctx, xk).forEach(c => body.append(c.name, c.value));
			}
		}
		body.append("postbackcomplete", 1);

		activeRequestCount++;
		const response = await fetchWithTimeout(url, {
			method: "POST",
			redirect: "error",
			headers: {
				"X-TeamDesk-UI-Version": "v3"
			},
			body,
			timeout: 2 * 60 * 1000
		});
		if (response.ok) {
			const r = await response.json();
			sendFormDataCallback(ctx, key, data, fromDoubleClick, r);
		}
	} finally {
		if (--activeRequestCount <= 0
			&& submitWasRequested
			&& ctx.matches("form")) {
			if(verifyRequired(ctx)) {
				FS.Form.disableButtons(ctx, true);
				submitWasRequested = false;
			}
			else {
				ctx.submit();
			}
			submitWasRequested = false;
		}
	}
}

function nextSiblingOf(elt, selector) {
	for (elt = elt.nextElementSibling; elt; elt = elt.nextElementSibling) {
		if (elt.matches(selector))
			return elt;
	}
	return null;
}

function takeSiblingsUntil(elt, selector) {
	const result = [];
	for (elt = elt.nextElementSibling; elt; elt = elt.nextElementSibling) {
		if (!elt.matches(selector))
			result.push(elt);
	}
	return result;
}

function sendFormDataCallback(ctx, key, data, fromDoubleClick, r) {
	function setHidden(ctx, data, q, type) {
		if (data.controls[q]) {
			if (!type) type = data.controls[q].t;
			var f = type == 1 || type == 2 ? controlBehaviors[data.controls[q].e] : controlBehaviors.input;
			// create cf
			var v = f.getValue(ctx, q);
			v = f.asString(v);
			var of = $$(ctx, "o_" + q);
			if (!of.length) {
				of = createElement("input", {type:"hidden", name:"o_" + q});
				ctx.insertBefore(of, ctx.firstChild);
				of = [ of ];
			}
			of[0].value = v;
		}
	}

	if (!fromDoubleClick) {
		var cf = $$(ctx, "c_" + key);
		if (!cf.length) {
			cf = createElement("input", {type:"hidden", name:"c_" + key});
			ctx.insertBefore(cf, ctx.firstChild);
			cf = [cf];
		}
		cf[0].value = 1;
	}

	setHidden(ctx, data, key);

	const changedLabels = [];
	for (var q in r) {
		if (data.controls[q]) {
			var rq = r[q];
			// type: 1 - editable, 2 - required, 4 - readonly, 5 - hidden
			var type = rq.type;
			var align = rq.align;
			// manage state
			var label = ctx.querySelector("#" + q + "_label");
			// no label for row edit
			if (label != null) {
				label.classList.toggle("v3-state-editable", !!rq.ae);
				if (label.matches("td,th")) {
					const cellValue = nextSiblingOf(label, "td");
					cellValue.classList.toggle("fs-edit", type == 1 || type == 2);
					cellValue.classList.toggle("v3-gridlayout-cell--edit", type == 1 || type == 2);
					cellValue.classList.toggle("v3-state-required", type == 2);
					const cells = takeSiblingsUntil(label, "th");
					cells.unshift(label);
					cells.forEach(e => e.classList.toggle("v3-state-hidden", type == 5));
				} else {
					label.classList.remove("v3-ctrl-progress");
					label.classList.toggle("ui-hidden", type == 5);
					label.classList.toggle("v3-state-hidden", type == 5);
					label.classList.toggle("ui-required", type == 2);
					label.classList.toggle("v3-state-required", type == 2);
					label.classList.toggle("ui-invalid", false);
					label.classList.toggle("v3-state-invalid", false);
					const cellValue = label.querySelector("dd.v3-gridlayout-cell__value");
					cellValue.classList.toggle("fs-alignright", align == "right" && (type == 3 || type == 4));
					cellValue.classList.toggle("v3-gridlayout-cell--align-right", align == "right" && (type == 3 || type == 4));
					cellValue.classList.toggle("fs-edit", type == 1 || type == 2);
					cellValue.classList.toggle("v3-gridlayout-cell--edit", type == 1 || type == 2);
					/* visible and changed? - animate! */
					if (type != 5 && (rq.html !== undefined || rq.value !== undefined)) {
						changedLabels.push(label);
					}
				}
			}
			var f = type == 1 || type == 2 ? controlBehaviors[data.controls[q].e] : controlBehaviors.input;
			data.controls[q].t = type;
			if (rq.html !== undefined)
				f.setHTML(ctx, q, rq.html);
			else if (r[q].value !== undefined)
				f.setValue(ctx, q, rq.value);
			/*
			if (data.dependencies[q])
				setChangeCallback(ctx, q, data);
			*/
		}
		else if (q == "sections" || q == "texts") {
			for (var s in r[q]) {
				var t = r[q][s];
				s = ctx.querySelector(q == "sections" ? "#section_" + s : "[id=\"" + s + "_label\"]" /* QS fails on #12345_label */);
				s.classList.toggle("v3-state-hidden", t == "hidden");
				s.classList.toggle("ui-hidden", t == "hidden");
				if (q == "sections") {
					var isCollapsed = t == "collapsed";
					var isExpanded = t == "expanded";
					var h = s.querySelector(".v3-gridlayout-section__title");
					if (h) {
						if (isCollapsed || isExpanded) {
							h.classList.add("ui-sectiontoggle", "ui-icon-" + (isCollapsed ? "collapsed" : "expanded"));
						} else {
							h.classList.remove("ui-sectiontoggle", "ui-icon-expanded", "ui-icon-collapsed");
						}
					}
					s.classList.toggle("v3-state-collapsed", isCollapsed);
					s.classList.toggle("v3-state-expanded", isExpanded);
				}
			}
		}
	}
	if (changedLabels.length) {
		changedLabels.forEach(label => label.classList.add("v3-state-changing"));
		setTimeout(() => changedLabels.forEach(label => { const lc = label.classList; lc.remove("v3-state-changing"); lc.add("v3-state-changed"); }), 300);
	}

	for (var qq in r)
		setHidden(ctx, data, qq, r[qq].type);
	initDynControls(ctx);
	verifyRequired(ctx, true);
	if (fromDoubleClick) {
		setFocus(ctx.querySelector("#" + key + "_label"));
	}
}


function appendLoadProgress(cell) {
	cell.classList.add("v3-ctrl-progress");
}

async function startDoubleClickEdit(ctx, data, dl, btn) {
	var id = /(f_\d+)_label/.exec(dl.id);
	// miss
	try {
		if (id == null) return;
		id = id[1];
		var ectl = $$(ctx, "e_" + id);
		if (!ectl.length) {
			ectl = createElement("input", { type: "hidden", name: "e_" + id, value: "1" });
			ctx.insertBefore(ectl, ectl.firstChild);
			ectl = [ectl];
		}
		else if (ectl[0].value == "1") {
			return;
		}
		else {
			ectl[0].value = "1";
		}
		var layout = ctx.querySelector(".v3-gridlayout");
		if (!layout.matches(".v3-gridlayout-cell--edit")) {
			layout.classList.add("v3-gridlayout-cell--edit");
			initButtons(ctx, ctx.id, data);
		}
		appendLoadProgress(dl);
		await sendFormData(ctx, id, data, true);
	} finally {
		btn.remove();
	}
}

function initEditableHover(ctx, data) {
	const btn = createElement("a", {
		id:"td-startedit",
		class:"v3-startedit-button v3-button ui-icon-only",
		href:"#"
	});

	btn.addEventListener("click", e => {
		e.preventDefault();
		e.stopPropagation();
		const dl = e.target.closest("dl.v3-gridlayout-cell.v3-state-editable");
		if (dl) {
			startDoubleClickEdit(ctx, data, dl, btn);
		}
	});

	var dlSelector = "dl[id^=\"f_\"].v3-gridlayout-cell:not(.v3-ctrl-progress)";
	var ddSelector = "dd.v3-gridlayout-cell__value:not(.v3-gridlayout-cell--edit)";

	if (!touchEvents) {
		ctx.addEventListener("dblclick", e => {
			var dl = e.target.closest(dlSelector + ".v3-state-editable");
			if (dl && dl.querySelector(ddSelector)) {
				startDoubleClickEdit(ctx, data, dl, btn);
				e.preventDefault();
			}
		});
		ctx.addEventListener("mouseout", () => {
			btn.classList.add("v3-state-hidden");
		});
	}

	function onClickOrMouseOver(e) {
		var cellValue = e.target.closest(ddSelector);
		if (cellValue) {
			var cell = cellValue.parentNode;
			if (cell.matches(dlSelector)) {
				if (btn.parentNode != cellValue) {
					btn.remove();
					cellValue.appendChild(btn);
				}
				btn.classList.remove("v3-state-hidden");
			}
		}
	}
	ctx.addEventListener("click", onClickOrMouseOver);
	ctx.addEventListener("mouseover", onClickOrMouseOver);
}

function setMessage(cell, messageText) {
	var hasError = messageText != null && messageText !== "";
	var messageBox = cell.querySelector(".v3-layout-cell__error");
	if (!hasError) {
		messageBox?.remove();
	} else {
		if (!messageBox) {
			messageBox = createElement("div", { class:"v3-gridlayout-cell__error v3-layout-cell__error v3-error"});
			cell.append(messageBox);
		}
		messageBox.replaceChildren(messageText);
	}
}

/* Not used, for a future experiments */
// eslint-disable-next-line no-unused-vars
function verifyRequiredNew(ctx, suppressMessages) {

	const form = ctx.closest("form");

	let cellSelector, cellBlockSelector, cellLabelSelector;
	let layout = ctx.querySelector("table.fs-layout");
	if (layout) {
		cellSelector = "td";
		cellBlockSelector = "td";
	}
	else {
		layout = ctx.querySelector(".v3-gridlayout");
		cellSelector = ".v3-gridlayout-cell__value";
		cellBlockSelector = ".v3-gridlayout-cell";
		cellLabelSelector = ".v3-gridlayout-cell__label";
	}

	var errCount = 0, errHidden = {}, errHiddenCount = 0;
	if (!form.checkValidity()) {
		form.elements.forEach(el => {
			const validity = el.validity;
			var cell = el.closest(cellSelector);
			if (!cell) return;
			var cellBlock = cell.closest(cellBlockSelector);
			if (!cellBlock) return;

			if (validity.valid) {
				setMessage(el, "");
				return;
			}
			let messageText = "";
			errCount++;
			if (validity.valueMissing) {
				messageText = Res.getString("form.error_value_missing");
			} else if (validity.typeMismatch) {
				if (el.type === "email") {
					messageText = Res.getString("form.error_type_mismatch_email");
				} else if (el.type === "url") {
					messageText = Res.getString("form.error_type_mismatch_url");
				} else {
					messageText = el.validationMessage;
				}
			} else {
				messageText = el.validationMessage;
			}
			// If element is hidden, store its message and display it on top of the form
			if(el.offsetParent == null) {
				errHiddenCount++;
				if (cellLabelSelector) {
					const cellLabel = cellBlock.querySelector(cellLabelSelector);
					errHidden[cellLabel.textContent] = messageText;
				}
			} else {
				// otherwise display it in a cell
				setMessage(cell, messageText);
			}
		});
	}
	if (errCount !== 0 && !suppressMessages) {
		var hdr = layout.parentNode.querySelector(".v3-layout__header");
		let err = hdr.querySelector(".v3-layout__error");
		if (!err) {
			err = createElement("div", { class: "v3-layout__error ui-icon-error" });
			hdr.append(err);
		}
		err.replaceChildren(
			String.format(Res.getString("form.invaliddata.1"), errCount),
			createElement("br"),
		);
		if (errHiddenCount) {
			const a = createElement("a", { href: "#", class: "v3-layout__error-show-details", on: { click: e => e.preventDefault() } }, Res.getString("form.invaliddata.2"));
			err.append(a);
			const ul = createElement("ul", { class: "v3-layout__error-details" });
			err.append(ul);
			for (var key in errHidden) {
				const li = createElement("li", key + ": " + errHidden[key]);
				ul.append(li);
			}
		} else {
			err.append(Res.getString("form.invaliddata.2"));
		}
	}
	return errCount;
}

function verifyRequired(ctx, suppressMessages) {
	// let form = ctx.closest("form");

	let cellSelector, cellBlockSelector, cellLabelSelector;
	let layout = ctx.querySelector("table.fs-layout");
	if (layout) {
		cellSelector = "td";
		cellBlockSelector = "td";
	}
	else {
		layout = ctx.querySelector(".v3-gridlayout");
		cellSelector = ".v3-gridlayout-cell__value";
		cellBlockSelector = ".v3-gridlayout-cell";
		cellLabelSelector = ".v3-gridlayout-cell__label";
	}
	var errCount=0, errHidden = {}, errHiddenCount = 0;
	ctx.querySelectorAll(cellSelector).forEach(cell => {
		const cellBlock = cell.closest(cellBlockSelector);
		if (!cellBlock || !cellBlock.classList.contains("v3-state-required"))
			return;
		const m = /(f_\d+)_value$/.exec(cell.id);
		if (m && m.length) {
			let inputs = $$(ctx, m[1]);
			if(!inputs.length) {
				// multiline append/prepend ?
				inputs = $$(ctx, m[1] + "_h", m[1] + "_o");
			} else if(inputs.length == 1 && inputs[0].type == "file" && inputs[0].dataset.signature === "on") {
				const signHidden = $$(ctx, m[1] + "_sign");
				if(signHidden.length)
					inputs = signHidden;
			}
			if (inputs.length) {
				let value = [];
				inputs.forEach(input => {
					if (input.tagName != "INPUT" || (input.type != "checkbox" && input.type != "radio") || input.checked) 
						value.push(input.value);
				});
				value = value.join(" ").replace(/\s+$/, "");
				let messageText = "";
				if (!value.length) {
					errCount++;
					cellBlock.classList.add("v3-state-invalid");
					if (!suppressMessages) {
						messageText = Res.getString("form.error_value_missing");
						// If element is hidden, store its message and display it on top of the form
						if (cell.offsetParent == null) {
							errHiddenCount++;
							if (cellLabelSelector) {
								const cellLabel = cellBlock.querySelector(cellLabelSelector);
								errHidden[cellLabel.textContent] = messageText;
							}
						}
					}
				} else {
					cellBlock.classList.remove("v3-state-invalid");
				}
				setMessage(cell, messageText);
			}
		}
	});
	if (errCount !== 0 && !suppressMessages) {
		var hdr = layout.parentNode.querySelector(".v3-layout__header");
		let err = hdr.querySelector(".v3-layout__error");
		if (!err) {
			err = createElement("div", { class:"v3-layout__error v3-error ui-icon-error"});
			hdr.appendChild(err);
		}
		err.replaceChildren(
			String.format(Res.getString("form.invaliddata.1"), errCount),
			createElement('br'),
		);
		if (errHiddenCount) {
			const a = createElement("a", { href: "#", class: "v3-layout__error-show-details", on: { click: e => e.preventDefault() } }, Res.getString("form.invaliddata.2"));
			err.append(a);
			const ul = createElement("ul", { class: "v3-layout__error-details" });
			err.append(ul);
			for (var key in errHidden) {
				const li = createElement("li", key + ": " + errHidden[key]);
				ul.append(li);
			}
		} else {
			err.append(Res.getString("form.invaliddata.2"));
		}
	}
	return errCount;
}

function initDeps(ctx, data) {
	ctx.addEventListener("change", e => {
		const c = e.target;
		const key = c.name;
		if (data.dependencies[c.name]) {
			// const elt = data.controls[key];
			// console.log(c.name, elt, "triggered change event");
			sendFormData(ctx, key, data);
		}/* else {
			verifyRequired(ctx);
		}*/
	});
}

function catchup(ctx, config, callback) {
	if (ctx.matches("form.v3-form")) {
		ctx.onsubmit = null;
		ctx.removeEventListener("submit", FS.Form.onSubmit);
		ctx.addEventListener("submit", e => {
			// console.log("TDCtrl.catchup, on submit");
			FS.Form.disableButtons(ctx);
			if (activeRequestCount > 0) {
				submitWasRequested = true;
				e.preventDefault();
				// console.log("Prevented, request in progress");
				return;
			}
			if (verifyRequired(ctx)) {
				FS.Form.disableButtons(ctx, true);
				e.preventDefault();
				// console.log("Prevented, required values missing");
				return;
			}
		});
		if (config.preview)
			initEdit(ctx, config);
		initChangeTracking(ctx);
	}
	initDeps(ctx, config);
	initForm(ctx);
	if (ctx.closest("main#td-bodyframe") != null) {
		setFocus(ctx);
	}
	callback?.(ctx);
}

export { initForm, initDeps, catchup, setFocus, addInitControl };